import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import Modal from "react-modal";
import { Button } from "react-bootstrap";
import CommonHeadingNBtns from "../../common-components/CommonHeadingNBtns";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import { commonPostPutApi } from "../../../redux/reducers/commonApiSlice";
import { approve_reject_couple_membership_request } from "../../../data/ApiEndpoints";
import "../../../styles/payment-link/deffered-payments.css";
import { NoPic } from "../../../exports/Images";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";
import DetailListings from "../couple-approval/DetailListings";

const DFApprovalForm = ({
  userInfoData,
  rowData,
  closeModal,
  callFunction,
  isViewOnly,
}) => {
  const dispatch = useDispatch();
  const { postPutLoading } = useSelector((state) => state.common);

  const isAdmin = userInfoData?.account_type === "admin";

  const documentDetails =
    rowData?.member_details?.map((member) => {
      const matchedDocument = rowData?.document_details?.find(
        (doc) => doc?.user_id === member?.user_id
      );

      return {
        ...member,
        document: matchedDocument?.document || null,
        uid: matchedDocument?.uid || null,
      };
    }) || [];

  // const documentDetails =
  //   rowData?.document_status === "completed" &&
  //   rowData?.document_details?.length > 0
  //     ? rowData.document_details
  //     : rowData?.member_details
  //     ? rowData.member_details
  //     : [];

  const forminitials = {
    description: "",
  };
  const [formValues, setFormValues] = useState(forminitials);
  const [formErrors, setFormErrors] = useState({});
  const iniModValues = {
    isModOpen: false,
    rowData: "",
    modName: "",
  };
  const [modValues, setModValues] = useState(iniModValues);

  function onCloseModal() {
    setModValues(iniModValues);
  }

  const validateForm = (formValues, isReject) => {
    let errors = {};

    if (isReject && !formValues.description) {
      errors.description = "required!";
    } else if (formValues.description?.length > 150) {
      errors.description = "required";
    }

    return errors;
  };

  const onSubmit = (isReject) => {
    const errors = validateForm(formValues, isReject);
    setFormErrors(errors);

    if (Object.keys(errors)?.length === 0) {
      const userData = {
        uid: rowData?.uid || "",
        approval_status: isReject ? "rejected" : "approved",
        remarks: formValues.description || "",
      };

      const handleConfirm = async () => {
        handleSubmitForm(userData);
      };

      showConfirmAlert(
        handleConfirm,
        `Have you checked that both documents are uploaded?`,
        "No, Check Form",
        "Yes, Submit Form"
      );
    }
  };

  const handleSubmitForm = async (payload) => {
    const method = "POST";
    const endpoint = approve_reject_couple_membership_request;
    const token = userInfoData?.token || "";

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        setFormValues(forminitials);
        callFunction();
        closeModal();
        toast.success(result?.payload?.message || "Success!");
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  console.log("documentDetails> ", documentDetails);

  return (
    <>
      <Modal
        isOpen={modValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Detail Modal"
        ariaHideApp={false}>
        <div className={`createNewCTOModalContainer modal-container-abs`}>
          <ModalHeadAndClose
            title={
              modValues.rowData?.name || modValues.modName?.replace(/_/g, " ")
            }
            onClose={onCloseModal}
          />

          <div className="discussionModalMessage">
            <img src={modValues.image} alt={modValues.rowData?.name} />
          </div>
        </div>
      </Modal>

      <div className={`createNewCTOModalContainer mod-width-50p`}>
        <CommonHeadingNBtns
          title={"Couple Membership Request Approval"}
          onClose={isViewOnly ? closeModal : null}
          isLoading={postPutLoading}
        />

        <div className="couple-details-container mt30">
          {documentDetails.map((user, index) => (
            <div key={index} className="couple-card">
              <h3>
                {user?.name || ""}
                {rowData?.url && (
                  <a
                    // href={`https://www.wtfgyms.com/couple-plan?mid=${user?.user_id}&rid=${user?.uid}`}
                    href={rowData.url}
                    target="_blank"
                    rel="noreferrer"
                    className="link">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-box-arrow-up-right"
                      viewBox="0 0 16 16">
                      <path
                        fillRule="evenodd"
                        d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5"
                      />
                      <path
                        fillRule="evenodd"
                        d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0z"
                      />
                    </svg>
                  </a>
                )}
              </h3>
              <p>{user?.mobile || "NA"}</p>
              <p>{user?.email || "NA"}</p>

              {user.document ? (
                <>
                  {user?.document?.toLowerCase()?.endsWith(".pdf") ? (
                    <a
                      href={user.document}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="document-link">
                      View Document
                    </a>
                  ) : (
                    <div className="image-container">
                      <img
                        src={user?.document || NoPic}
                        alt="User Document"
                        className="document-image"
                        onClick={() => {
                          setModValues((prevs) => ({
                            ...prevs,
                            isModOpen: true,
                            modName: "staff_photo",
                            image: user?.document || NoPic,
                            rowData: user,
                          }));
                        }}
                      />
                    </div>
                  )}
                </>
              ) : (
                <div className="formButtons mt30">
                  <Button
                    type="button"
                    className="saveBtn"
                    variant="warning"
                    disabled>
                    document pending
                  </Button>
                </div>
              )}
            </div>
          ))}
        </div>

        {!isViewOnly ? (
          <form className="formContainer mb30">
            <div className="formInputsGrid oneGridSystem">
              <div className="formInputBox span4">
                <label htmlFor="description" className="formInputLabel">
                  Enter remarks{" "}
                  <small>
                    (Remarks is mandatory if rejecting. Max 150 -{" "}
                    {formValues.description?.length}){" "}
                    {formErrors.description ? (
                      <span className="required">*</span>
                    ) : null}
                  </small>
                </label>

                <textarea
                  name="description"
                  className={`formInput ${
                    formErrors.description ? "formError" : ""
                  }`}
                  style={{
                    background: "#fff",
                  }}
                  placeholder="Enter Remarks"
                  value={formValues.description || ""}
                  onChange={(e) =>
                    setFormValues((prevs) => ({
                      ...prevs,
                      description: e.target.value,
                    }))
                  }></textarea>
              </div>
            </div>

            <div className="formButtons" style={{ justifyContent: "flex-end" }}>
              <Button className="saveBtn" variant="dark" onClick={closeModal}>
                close
              </Button>

              {isAdmin && (
                <>
                  <Button
                    className="saveBtn"
                    variant="primary"
                    onClick={() => onSubmit(false)}>
                    approve
                  </Button>
                  <Button
                    className="saveBtn"
                    variant="danger"
                    onClick={() => onSubmit(true)}>
                    reject
                  </Button>
                </>
              )}
            </div>
          </form>
        ) : rowData?.approval_status !== "pending" ? (
          <DetailListings row={rowData} isOnlyInfo={true} />
        ) : null}
      </div>
    </>
  );
};

export default DFApprovalForm;
